<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :class="`${customStyle} stroke-slate-500`"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    fill="none"
    stroke-linecap="round"
    stroke-linejoin="round"
  >
    <path
      stroke="none"
      d="M0 0h24v24H0z"
      fill="none"
    />
    <path d="M7 5h6a3.5 3.5 0 0 1 0 7h-6z" />
    <path d="M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7" />
  </svg>
</template>

<script>
export default {
  name: 'BoldIcon',

  props: {
    customStyle: {
      type: String,
      default: 'h-5 w-5',
    },
  },
}
</script>
